(() => {
  'use strict';
  const main = document.querySelector('main[data-template="index"]');
  if (!main) return;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const styleId = 'krish-scroll-reveal-styles';
  if (!document.getElementById(styleId)) {
    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = `
      main[data-template="index"] .shopify-section[data-krish-reveal] {
        opacity: 0; transform: translate3d(0, 28px, 0); filter: blur(1.5px);
        transition: opacity 720ms ease, transform 800ms cubic-bezier(.2,.7,.2,1), filter 720ms ease;
      }
      main[data-template="index"] .shopify-section.krish-reveal-visible {
        opacity: 1; transform: translate3d(0,0,0); filter: blur(0);
      }
      main[data-template="index"] .krish-text-reveal {
        opacity: 0; transform: translate3d(0, 24px, 0); filter: blur(3px);
        transition: opacity 760ms cubic-bezier(.2,.7,.2,1), transform 820ms cubic-bezier(.2,.7,.2,1), filter 760ms ease;
        transition-delay: var(--krish-text-delay, 0ms);
      }
      main[data-template="index"] .krish-reveal-visible .krish-text-reveal {
        opacity: 1; transform: translate3d(0,0,0); filter: blur(0);
      }
      main[data-template="index"] .krish-word {
        display: inline-block; opacity: 0; transform: translate3d(0, 115%, 0) rotate(2deg);
        filter: blur(4px); transition: opacity 650ms ease, transform 760ms cubic-bezier(.16,1,.3,1), filter 650ms ease;
        transition-delay: var(--krish-word-delay, 0ms); will-change: transform, opacity;
      }
      main[data-template="index"] .krish-reveal-visible .krish-word {
        opacity: 1; transform: translate3d(0,0,0) rotate(0); filter: blur(0); will-change: auto;
      }
      main[data-template="index"] .krish-word-wrap { display: inline-block; overflow: hidden; vertical-align: bottom; padding-block: .08em; margin-block: -.08em; }
      @media (prefers-reduced-motion: no-preference) {
        main[data-template="index"] .shopify-section .card-gallery {
          overflow: hidden; transition: box-shadow 450ms ease;
        }
        main[data-template="index"] .shopify-section .card-gallery img,
        main[data-template="index"] .shopify-section .banner__media img,
        main[data-template="index"] .shopify-section .media img {
          transition: transform 850ms cubic-bezier(.2,.7,.2,1), filter 500ms ease;
        }
        main[data-template="index"] .shopify-section .card-gallery:hover img,
        main[data-template="index"] .shopify-section .banner__media:hover img,
        main[data-template="index"] .shopify-section .media:hover img {
          transform: scale(1.045); filter: saturate(1.04);
        }
        main[data-template="index"] .shopify-section .product-card:hover .card-gallery {
          box-shadow: 0 16px 36px rgb(49 36 20 / 12%);
        }
        main[data-template="index"] .shopify-section .button {
          transition: transform 260ms ease, box-shadow 260ms ease, background-color 260ms ease;
        }
        main[data-template="index"] .shopify-section .button:hover {
          transform: translateY(-2px); box-shadow: 0 8px 22px rgb(68 48 28 / 13%);
        }
      }
      @media (prefers-reduced-motion: reduce) {
        main[data-template="index"] .shopify-section[data-krish-reveal],
        main[data-template="index"] .krish-text-reveal,
        main[data-template="index"] .krish-word {
          opacity: 1 !important; transform: none !important; filter: none !important;
          transition: none !important; will-change: auto;
        }
      }`;
    document.head.appendChild(style);
  }

  const headingSelector = 'h1,h2,h3,h4,.h0,.h1,.h2,.h3,.section-header__heading,.rich-text__heading';
  const textSelector = 'p,.rte,.text-block,.section-header__description,.banner__text,.image-with-text__text';
  const motionTargets = [
    '.product-card', '.card-wrapper', '.banner__content', '.image-with-text__content',
    '.collection-list__item', '.slideshow__text-wrapper', '.multicolumn-card'
  ].join(',');

  const splitHeadingWords = (heading) => {
    if (heading.dataset.krishWords === 'true' || heading.children.length > 0) return;
    const raw = heading.textContent.trim();
    if (!raw || raw.length > 180) return;
    const words = raw.split(/\s+/);
    if (words.length < 2 || words.length > 18) return;
    heading.setAttribute('aria-label', raw);
    heading.setAttribute('data-krish-words', 'true');
    const fragment = document.createDocumentFragment();
    words.forEach((word, index) => {
      const wrap = document.createElement('span');
      wrap.className = 'krish-word-wrap';
      const inner = document.createElement('span');
      inner.className = 'krish-word';
      inner.style.setProperty('--krish-word-delay', (index * 65) + 'ms');
      inner.setAttribute('aria-hidden', 'true');
      inner.textContent = word;
      wrap.appendChild(inner);
      fragment.appendChild(wrap);
      if (index < words.length - 1) fragment.appendChild(document.createTextNode(' '));
    });
    heading.replaceChildren(fragment);
  };

  const prepareItems = (root) => {
    if (!root.querySelectorAll) return;
    root.querySelectorAll(headingSelector).forEach((item, index) => {
      splitHeadingWords(item);
      if (!item.classList.contains('krish-text-reveal')) item.classList.add('krish-text-reveal');
      item.style.setProperty('--krish-text-delay', Math.min(index, 5) * 70 + 'ms');
    });
    root.querySelectorAll(textSelector).forEach((item, index) => {
      if (!item.classList.contains('krish-text-reveal')) item.classList.add('krish-text-reveal');
      item.style.setProperty('--krish-text-delay', (100 + Math.min(index, 5) * 75) + 'ms');
    });
    root.querySelectorAll(motionTargets).forEach((item) => {
      if (!item.classList.contains('krish-item-reveal')) item.classList.add('krish-item-reveal');
    });
  };

  if (reducedMotion || !('IntersectionObserver' in window)) {
    main.querySelectorAll('.shopify-section').forEach((section) => {
      section.classList.add('krish-reveal-visible');
      prepareItems(section);
    });
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('krish-reveal-visible');
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -28px 0px' });

  const observeSections = (root) => {
    const sections = [];
    if (root.matches && root.matches('.shopify-section')) sections.push(root);
    if (root.querySelectorAll) sections.push(...root.querySelectorAll('.shopify-section'));
    sections.forEach((section) => {
      if (section.dataset.krishReveal === 'true') return;
      section.dataset.krishReveal = 'true';
      prepareItems(section);
      observer.observe(section);
    });
  };

  observeSections(main);
  document.addEventListener('shopify:section:load', (event) => {
    if (main.contains(event.target)) observeSections(event.target);
  });

  main.addEventListener('click', (event) => {
    if (!window.matchMedia('(hover: none), (pointer: coarse)').matches) return;
    const link = event.target.closest('.card-gallery > a');
    if (!link) return;
    const gallery = link.closest('.card-gallery');
    const slideshow = gallery && gallery.querySelector('slideshow-component');
    if (!slideshow) return;
    if (gallery.dataset.krishTouchPreview === 'true') {
      gallery.dataset.krishTouchPreview = 'false';
      return;
    }
    if (slideshow.querySelectorAll('slideshow-slide').length < 2) return;
    event.preventDefault();
    event.stopPropagation();
    gallery.dataset.krishTouchPreview = 'true';
    try {
      if (typeof slideshow.next === 'function') slideshow.next();
      else if (typeof slideshow.select === 'function') slideshow.select(1);
    } catch (_) {}
  }, true);
})();